import { Component, Input, OnInit } from '@angular/core';
import { enumPaymentState } from '@data-layer/enums/payments/enumPaymentState';

@Component({
  selector: 'bill-status',
  templateUrl: './bill-status.component.html',
  styleUrls: ['./bill-status.component.scss'],
})
export class BillStatusComponent implements OnInit {
  @Input() public billStatus: enumPaymentState;
  @Input() public showValue: boolean = false;
  constructor() {}

  public ngOnInit(): void {}
}
